import { useTranslation } from 'react-i18next'

import { QA_NAME_RESET_SORTING_BTN } from '../../../../constants/qa'
import { TableControlIcon } from '../../TableControlIcon'

import SortingIcon from '../../../../icons/sorting-1.svg'

function TableResetSortingButton({
  qaName = QA_NAME_RESET_SORTING_BTN,
  tooltip = 'Table.ResetSortingBtnKey',
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <TableControlIcon
      {...restProps}
      Icon={SortingIcon}
      qaName={qaName}
      tooltip={t(tooltip)}
    />
  )
}

export default TableResetSortingButton
